"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const xstate_1 = require("xstate");
const prop_types_1 = require("prop-types");
const AppointmentCancel_1 = __importDefault(require("./AppointmentCancel"));
const xstate_2 = require("../../lib/constants/xstate");
class AppointmentCancelContainer extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleMachineTransition = (currentState) => {
            this.props.logState(currentState);
        };
        this.service = (0, xstate_1.interpret)(props.machine).onTransition(this.handleMachineTransition);
    }
    componentDidMount() {
        this.service.start();
        this.service.send(xstate_2.events.initialized);
    }
    componentWillUnmount() {
        this.service.stop();
    }
    render() {
        return (react_1.default.createElement(AppointmentCancel_1.default, { createRescheduleLink: this.props.createRescheduleLink, service: this.service, track: this.props.track, searchProvidersLink: this.props.searchProvidersLink }));
    }
}
AppointmentCancelContainer.propTypes = {
    /* eslint-disable react/forbid-prop-types */
    /**
     * Callback that takes a providerId and returns a URL to be used as a hyperlink to reschedule with the appointment provider
     * @callback createRescheduleLink
     * @param {number} providerId
     */
    createRescheduleLink: prop_types_1.func.isRequired,
    /**
     * devLogger for the state machine to help with debugging
     */
    logState: prop_types_1.func,
    /**
     * The appointmentCancelMachine that will handle the logic of the AppointmentCancelComponent
     */
    machine: (0, prop_types_1.instanceOf)(xstate_1.StateNode).isRequired,
    /**
     * Callback triggered for tracking
     * @callback track
     * @param {string} eventName
     * @param {object} eventData
     */
    track: prop_types_1.func.isRequired,
    /**
     * URL link for the `Search Providers` button.
     */
    searchProvidersLink: prop_types_1.string.isRequired
};
AppointmentCancelContainer.defaultProps = {
    logState: () => { }
};
exports.default = AppointmentCancelContainer;
//# sourceMappingURL=AppointmentCancelContainer.js.map